import { useContext } from 'react'
import { RootStoreContext } from '../../../_stores/rootStore'

export default function useTargetingPermissions() {
    const rootStore = useContext(RootStoreContext)
    const { permissions } = rootStore.permissionsStore
    const { user } = rootStore.userStore

    if (!user) {
        return {
            isAppAdmin: false,
            isMultiExerciseAdmin: false,
            isAdminUser: false,
            isMultiExerciseUser: false,
            isElevatedViewer: false,
        }
    }

    const { appAdmin, multiExercise, elevatedViewers } = permissions.targeting.global

    const isAppAdmin = appAdmin.roles.includes(user.role)
    const isMultiExerciseAdmin =
        multiExercise.adminLevel.roles.includes(user.role) &&
        multiExercise.adminLevel.teams.includes(user.team)
    const isAdminUser = isAppAdmin || isMultiExerciseAdmin
    const isMultiExerciseUser =
        !isAdminUser && multiExercise.userLevel.teams.includes(user.team)
    const isElevatedViewer = elevatedViewers.roles.includes(user.role)

    return {
        isAppAdmin,
        isMultiExerciseAdmin,
        isAdminUser,
        isMultiExerciseUser,
        isElevatedViewer,
    }
}
